import { useState } from 'react'
import { MediaDrawer } from './MediaDrawer'
import { SelectMediaDrawerProps, SelectMediaProps } from '../Types'
import { MediaFileGrid } from './MediaFileGrid'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useDebounce } from 'hooks/useDebounce'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './MediaDrawer.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'
import { getVideoMimeType } from 'components/Design/UploadsTab/components/StockVideosGallery'
import { useStockVideos } from 'hooks/queries/designer/useStockVideos'

interface StockVideosDrawerProps extends SelectMediaDrawerProps {}

export const StockVideosDrawer = observer((props: StockVideosDrawerProps) => {
  const { onSelect, ...rest } = props
  const { closeDrawer } = useRootStore().drawersStore
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, 500)
  const { isLoading, data } = useStockVideos({
    query: debouncedQuery,
    pageSize: 6,
    videoType: 'all',
  })
  const showNoResults = query.length > 0 && !isLoading && !data?.pages[0].videos.length

  const videos = data?.pages.flatMap((page) => page.videos) || []


  const files = videos.map((video) => ({
    id: video.id,
    source_url: video.videos.medium.url,
    duration: video.duration,
    variants: [],
    mime_type: video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url),
    title: video.id,
    thumbnail_url: video.videos.medium.thumbnail,
  }))

  const handleSelect = ({ file, needsDownload }: SelectMediaProps) => {
    onSelect({ file, needsDownload, provider: 'stockVideo' })
    closeDrawer()
  }

  return (
    <MediaDrawer {...rest}>
      <div className={Styles.searchContainer}>
        <Input
          name="Search"
          variant="grey"
          size="lg"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search stock videos..."
          autoComplete="off"
        />
        {showNoResults && <Text variant="largeList">No results found for {query}.</Text>}
        <MediaFileGrid mediaFiles={files} onSelect={handleSelect} isLoading={isLoading} needsDownload />
      </div>
    </MediaDrawer>
  )
})
